// ================= MONTH HELPERS =================
export const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const getMonthNbr = (dateString) => {
    const date = new Date(dateString);
    return date.getMonth();
};


// ================= MONTHLY FINISH RATE =================
export const calculateFinishRate = (userCoursesData) => {
    const monthStats = {};

    userCoursesData.forEach((item) => {
        const monthIndex = getMonthNbr(item.startTime);

        if (!monthStats[monthIndex]) {
            monthStats[monthIndex] = { completed: 0, total: 0 };
        }

        monthStats[monthIndex].total += 1;

        if (item.isCourseCompleted) {
            monthStats[monthIndex].completed += 1;
        }
    });

    const result = [];

    Object.keys(monthStats)
        .sort((a, b) => a - b)
        .forEach((monthIndex) => {
            const { completed, total } = monthStats[monthIndex];

            const finishRate = total === 0 ? 0 : (completed / total) * 100;

            result.push({
                finishRate: Math.round(finishRate),
                month: monthNames[monthIndex],
            });
        });

    return result;
};


// ================= TOP COURSES (GENERIC DATA) =================
export const calculateTop5FinishRate = (userCoursesData, coursesObj) => {

    if (!coursesObj) return [];

    // ✅ Convert coursesObj → array
    const coursesArray = Object.values(coursesObj);

    // ✅ Get latest 7 courses (based on courseID)
    const latestCourses = coursesArray
        .sort((a, b) => b.courseID - a.courseID)
        .slice(0, 5);

    const result = latestCourses.map((course) => {

        const courseId = Number(course.courseID);

        // ✅ Filter userCourses for this course
        const relatedUserCourses = userCoursesData.filter(
            (uc) => Number(uc.courseID) === courseId
        );

        const total = relatedUserCourses.length;

        const completed = relatedUserCourses.filter(
            (uc) => uc.isCourseCompleted
        ).length;

        const percentage = total === 0 ? 0 : (completed / total) * 100;

        return {
            courseId,
            courseName: course.courseName,
            percentage: Math.round(percentage),
        };
    });

    return result;
};


// ================= OPTIONAL: CHART FORMAT (if needed somewhere else) =================
export const mapTopCoursesToChartFormat = (topCourses) => {
    if (!topCourses) return [];

    return [
        {
            data: topCourses.map(x => x.percentage),
            label: 'Completion %'
        }
    ];
};


// ================= PASS / FAIL PIE CHART =================
export const calculatePassPercentageChartData = (userCoursesData) => {
    const allDidntFinishDetails = { id: 0, value: 0, label: "Pending" };
    const allFinishedDetails = { id: 1, value: 0, label: "Completed" };

    userCoursesData.forEach((x) => {
        if (x.isCourseCompleted) {
            allFinishedDetails.value += 1;
        } else {
            allDidntFinishDetails.value += 1;
        }
    });

    return [allDidntFinishDetails, allFinishedDetails];
};


// ================= FORMATTERS =================
export const percentageFormatter = (value) => `${value}%`;